import { each } from 'lodash';
import Swiper from 'swiper/bundle';
export default class CarouselRelated {
    constructor() {
        this.carousel = {
            elements: document.querySelectorAll('.carousel[data-carousel="related"]'),
        }

        each(this.carousel.elements, (carousel) => {
            this.createCarousel(carousel); // Init Carousel
        });
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}